var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"focusable":"false","viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }